import React from "react";
import "./Loader.css";

// A single reusable, on-brand loading indicator.
// - fullScreen: covers the viewport (route/page-level loads)
// - inline (default): sits centered inside whatever section is loading
const Loader = ({ fullScreen = false, label = "Loading...", size = 84 }) => {
  const ticks = Array.from({ length: 12 });

  const mark = (
    <div className="astro-loader" style={{ "--astro-loader-size": `${size}px` }}>
      <div className="astro-loader-ring">
        {ticks.map((_, i) => (
          <span
            key={i}
            className="astro-loader-tick"
            style={{ "--i": i }}
          />
        ))}

        <span className="astro-loader-arc" />
        <span className="astro-loader-core" />
      </div>

      {label && (
        <div className="astro-loader-label">
          <span>{label}</span>
          <span className="astro-loader-shimmer" />
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="astro-loader-overlay" role="status" aria-live="polite">
        {mark}
      </div>
    );
  }

  return (
    <div className="astro-loader-inline" role="status" aria-live="polite">
      {mark}
    </div>
  );
};

export default Loader;
